import {SINGLE_RELATIONSHIP_TYPE} from "./shared-types";
import {AuditMixin, AuditMixinAttributes, AuditMixinRelationships} from "./audit-mixin";

export class ComponentTypeComponentTypeAttributes extends AuditMixinAttributes {
    first_is_unique: boolean;
    second_is_unique: boolean;
}

export class ComponentTypeComponentTypeRelationships extends AuditMixinRelationships {
    first_component_type: SINGLE_RELATIONSHIP_TYPE;
    second_component_type: SINGLE_RELATIONSHIP_TYPE;
}

export class ComponentTypeComponentType extends AuditMixin {
    attributes: ComponentTypeComponentTypeAttributes;
    id: string;
    type: string = 'component_component';
    relationships: ComponentTypeComponentTypeRelationships;

    constructor() {
        super();
        this.attributes = new ComponentTypeComponentTypeAttributes();
        this.relationships = new ComponentTypeComponentTypeRelationships();
    }
}

export class ComponentTypeComponentTypeLinkRequest {
    first_component_type_id: string;
    second_component_type_id: string;
    first_is_unique: boolean;
    second_is_unique: boolean;
    automatic_linking_rule?: string;
    automatic_unlink?: boolean;

    constructor(data: Partial<ComponentTypeComponentTypeLinkRequest> = {}) {
        Object.assign(this, data);
    }
}

export class EventTypeComponentTypeLinkRequest {
    event_type_id: string;
    component_type_id: string;
    has_one_event: boolean;
    has_one_component: boolean;
    automatic_linking_rule?: string;
    automatic_unlink?: boolean;

    constructor(data: Partial<EventTypeComponentTypeLinkRequest> = {}) {
        Object.assign(this, data);
    }
}
export class EventTypeComponentTypeDeleteRequest{
    event_type_id: string;
    component_type_id: string;
}
export class ComponentTypeComponentTypeDeleteRequest{
    first_component_type_id: string;
    second_component_type_id: string;
}
export class GetComponentTypeLinkRequest {
    component_type_id?: string;
    event_type_id?: string;

    constructor(data: Partial<GetComponentTypeLinkRequest> = {}) {
        Object.assign(this, data);
    }
}
